import { useLayoutEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ERROR, TError } from '@/app/store/fatalErrors';
import { signOut } from '@/modules/auth/store/actions';
import { AppDispatch } from '@/root-store';

import { AccountBlockedError } from './components/AccountBlockedError';
import { ErrorLayout } from './ErrorLayout';

const ErrorBySlug = ({ slug }: { slug: TError | string }) => {
  const dispatch: AppDispatch = useDispatch();

  useLayoutEffect(() => {
    if (slug === ERROR.LOGIN_REQUIRED) {
      dispatch(signOut());
    }
  }, [slug, dispatch]);

  switch (slug) {
    case ERROR.INTERNAL_SERVER_ERROR:
      return (
        <ErrorLayout
          code={500}
          title={
            <FormattedMessage
              defaultMessage="Internal server error"
              id="ZsUgbi"
              description="500 Error page title"
            />
          }
          description={
            <FormattedMessage
              defaultMessage="Something went wrong. please try again later."
              id="yCM2I2"
              description="500 Error page description"
            />
          }
        />
      );

    case ERROR.BAD_GATEWAY:
      return (
        <ErrorLayout
          code={502}
          title={
            <FormattedMessage
              defaultMessage="Bad gateway"
              id="Bl2mzQ"
              description="502 Error page title"
            />
          }
          description={
            <FormattedMessage
              defaultMessage="The server encountered a temporary error and could not complete your request. Please try again in 30 seconds."
              id="o4ivjh"
              description="502 Error page description"
            />
          }
        />
      );

    case ERROR.NOT_FOUND:
      return (
        <ErrorLayout
          code={404}
          title={
            <FormattedMessage
              defaultMessage="Page not found"
              id="HqlYmH"
              description="404 Error page title"
            />
          }
          description={
            <FormattedMessage
              defaultMessage="Error 404. This page doesn't exist."
              id="s9F+tE"
              description="404 Error page description"
            />
          }
          isLinkToIndexShown={true}
        />
      );

    case ERROR.BLOCKED:
      return (
        <ErrorLayout
          title={
            <FormattedMessage
              defaultMessage="Your account has been blocked"
              id="TDrhF6"
              description="Page title"
            />
          }
          description={<AccountBlockedError />}
        />
      );

    case ERROR.LOGIN_REQUIRED:
      return null;

    default:
      return (
        <ErrorLayout
          title={
            <FormattedMessage defaultMessage="Error" id="D7Dner" description="Error page title" />
          }
          description={
            <FormattedMessage
              defaultMessage="Something went wrong. please try again later."
              id="yCM2I2"
              description="500 Error page description"
            />
          }
        />
      );
  }
};

export { ErrorBySlug };
